import { useEffect, useState } from 'react';
import { getIncidenceTypes } from '../services/incidenceService';

// Cache global para los tipos de incidencias
let typesCache = null;
let typesCachePromise = null;

/**
 * Hook para obtener los tipos de incidencias con cache
 * Los tipos se cargan una sola vez y se cachean en memoria
 * 
 * @returns {{types: Array, loading: boolean, error: Error|null}}
 */
export function useIncidenceTypes() {
    const [types, setTypes] = useState(typesCache || []);
    const [loading, setLoading] = useState(!typesCache);
    const [error, setError] = useState(null);

    useEffect(() => {
       
        if (typesCache) {
            return;
        }

        // Si ya hay una petición en curso, esperar a que termine
        if (typesCachePromise) {
            typesCachePromise
                .then((data) => {
                    setTypes(data);
                    setLoading(false);
                })
                .catch((err) => {
                    setError(err);
                    setLoading(false);
                });
            return;
        }

        // Hacer la petición y cachear el resultado
        const ac = new AbortController();
        setLoading(true);
        setError(null);

        typesCachePromise = getIncidenceTypes({ signal: ac.signal })
            .then(async (response) => {
                if (response.ok) {
                    const data = await response.json();
                    typesCache = data;
                    setTypes(data);
                    return data;
                } else {
                    throw new Error('Failed to load incidence types');
                }
            })
            .catch((err) => {
                if (err.name !== 'AbortError') {
                    setError(err);
                    typesCache = null; // Limpiar cache en caso de error
                }
                throw err;
            })
            .finally(() => {
                setLoading(false);
                typesCachePromise = null;
            });

        return () => {
            ac.abort();
        };
    }, []);

    return { types, loading, error };
}
